import { useTranslation } from "react-i18next";
import { Plane } from "lucide-react";
import { AuthPage } from "@tabipla/components";
import { useAuth } from "@/application/hooks/useAuth";

const TABITTO_THEME = {
  iconBg: "bg-primary",
  iconText: "text-primary-foreground",
  buttonClass: "",
  backgroundGradient: "from-primary/5 via-background to-primary/10",
};

export function LoginPage() {
  const { t } = useTranslation();
  const { login, loginWithLine, isLoading } = useAuth();

  return (
    <AuthPage
      appName="Tabitto"
      tagline={t("app.tagline", "旅行計画をもっと楽しく")}
      icon={<Plane className="h-8 w-8" />}
      theme={TABITTO_THEME}
      mode="login"
      onLogin={login}
      onLoginWithLine={loginWithLine}
      isLoading={isLoading}
    />
  );
}
